export default "__VITE_ASSET__uWtvQsh1__"